import { Box } from '@hover/blueprint';
import React from 'react';

import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

const DEFAULT_SELECTION_TEXT = 'Select a color below to apply';

interface ColorLabelProps {
  selectedColorName?: string;
  selectedColor?: string;
}

const ColorLabel = ({ selectedColor, selectedColorName }: ColorLabelProps) => {
  const t = useTranslate(TranslationNamespace.DESIGN_STUDIO);

  return (
    <Box marginBottom={2} padding={100} testId="color-label">
      <Box
        background={
          selectedColor ? `radial-gradient(${selectedColor} 60%, #000)` : 'none'
        }
        borderColor={selectedColor ? 'primary.base' : 'lightgray'}
        borderRadius={900}
        borderStyle="solid"
        borderWidth="2px"
        display="inline-block"
        height={30}
        overflow="visible"
        padding="0px"
        width={30}
      />
      <Box
        style={{
          fontFamily: 'Adelle Sans',
          fontSize: 14,
          paddingLeft: 16,
          fontWeight: 600,
          color: selectedColor ? '#767676' : 'lightgray',
          lineHeight: '30px',
        }}
      >
        {selectedColor ? selectedColorName : t('menu.colorPicker.selectColor')}
      </Box>
    </Box>
  );
};

export { ColorLabel, DEFAULT_SELECTION_TEXT };
